"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abs_csv_export_1 = __importDefault(require("./abs_csv_export"));
var contact_tanto_object_1 = __importDefault(require("../../../common/src/utils/sales_force/contact_tanto_object"));
var SalesForceContactTantoExport = /** @class */ (function (_super) {
    __extends(SalesForceContactTantoExport, _super);
    function SalesForceContactTantoExport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesForceContactTantoExport.prototype.getCsvData = function (contractDocument, salesForceInfo) {
        return contact_tanto_object_1.default.create(contractDocument, salesForceInfo);
    };
    SalesForceContactTantoExport.prototype.getFileName = function () {
        return 'Contact_apply.csv';
    };
    return SalesForceContactTantoExport;
}(abs_csv_export_1.default));
exports.default = SalesForceContactTantoExport;



//////////////////
// WEBPACK FOOTER
// ./src/utils/sales_force/contact_tanto_export.ts
// module id = yAcs
// module chunks = 1